import TableCard from 'components/organisms/Admin/User/TableCard'
import React from 'react'

const User: React.VFC = () => {
  return <TableCard />
}

export default User
